module.exports = __webpack_public_path__ + "static/img/yellow.827276d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yellow.png
// module id = ZGfx
// module chunks = 1